import styled from 'styled-components'
import { Col } from 'antd';

export const Img = styled.img`
    width: 100%;
    height: 180px;
    content: url(${props => props.srcBig});
    display: block;
    margin-bottom: 30px;

    @media screen and (max-width: 1500px) {
        height: 165px;
        content: url(${props => props.srcMedium});
    }

    @media screen and (max-width: 768px) {
        height: 125px;
        content: url(${props => props.srcSmall});
    }
`

export const ColCualidades = styled(Col)`
    text-align: justify;
    margin-left: 8%;

    @media screen and (max-width: 1500px) {

    }

    @media screen and (max-width: 768px) {
        margin-left: 2%;
        padding-left: 0px !important;
        padding-right: 30px !important;
    }
`

export const Title = styled.h1`
    color: #DF8232;
`